function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/texttransformation
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TextWatcher from './textwatcher';
import { escapeRegExp } from 'lodash-es'; // All named transformations.

var TRANSFORMATIONS = {
  // Common symbols:
  copyright: {
    from: '(c)',
    to: '©'
  },
  registeredTrademark: {
    from: '(r)',
    to: '®'
  },
  trademark: {
    from: '(tm)',
    to: '™'
  },
  // Mathematical:
  oneHalf: {
    from: '1/2',
    to: '½'
  },
  oneThird: {
    from: '1/3',
    to: '⅓'
  },
  twoThirds: {
    from: '2/3',
    to: '⅔'
  },
  oneForth: {
    from: '1/4',
    to: '¼'
  },
  threeQuarters: {
    from: '3/4',
    to: '¾'
  },
  lessThanOrEqual: {
    from: '<=',
    to: '≤'
  },
  greaterThanOrEqual: {
    from: '>=',
    to: '≥'
  },
  notEqual: {
    from: '!=',
    to: '≠'
  },
  arrowLeft: {
    from: '<-',
    to: '←'
  },
  arrowRight: {
    from: '->',
    to: '→'
  },
  // Typography:
  horizontalEllipsis: {
    from: '...',
    to: '…'
  },
  enDash: {
    from: /(^| )(--)( )$/,
    to: [null, '–', null]
  },
  emDash: {
    from: /(^| )(---)( )$/,
    to: [null, '—', null]
  },
  // Quotations:
  // English, US
  quotesPrimary: {
    from: buildQuotesRegExp('"'),
    to: [null, '“', null, '”']
  },
  quotesSecondary: {
    from: buildQuotesRegExp('\''),
    to: [null, '‘', null, '’']
  },
  // English, UK
  quotesPrimaryEnGb: {
    from: buildQuotesRegExp('\''),
    to: [null, '‘', null, '’']
  },
  quotesSecondaryEnGb: {
    from: buildQuotesRegExp('"'),
    to: [null, '“', null, '”']
  },
  // Polish
  quotesPrimaryPl: {
    from: buildQuotesRegExp('"'),
    to: [null, '„', null, '”']
  },
  quotesSecondaryPl: {
    from: buildQuotesRegExp('\''),
    to: [null, '‚', null, '’']
  }
}; // Transformation groups.

var TRANSFORMATION_GROUPS = {
  symbols: ['copyright', 'registeredTrademark', 'trademark'],
  mathematical: ['oneHalf', 'oneThird', 'twoThirds', 'oneForth', 'threeQuarters', 'lessThanOrEqual', 'greaterThanOrEqual', 'notEqual', 'arrowLeft', 'arrowRight'],
  typography: ['horizontalEllipsis', 'enDash', 'emDash'],
  quotes: ['quotesPrimary', 'quotesSecondary']
}; // A set of default transformations provided by the feature.

var DEFAULT_TRANSFORMATIONS = ['symbols', 'mathematical', 'typography', 'quotes'];
/**
 * The text transformation plugin.
 *
 * @extends module:core/plugin~Plugin
 */

var TextTransformation = /*#__PURE__*/function (_Plugin) {
  _inherits(TextTransformation, _Plugin);

  var _super = _createSuper(TextTransformation);

  /**
   * @inheritDoc
   */
  function TextTransformation(editor) {
    var _this;

    _classCallCheck(this, TextTransformation);

    _this = _super.call(this, editor);
    editor.config.define('typing', {
      transformations: {
        include: DEFAULT_TRANSFORMATIONS
      }
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(TextTransformation, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var model = this.editor.model;
      var modelSelection = model.document.selection;
      modelSelection.on('change:range', function () {
        // Disable plugin when selection is inside a code block.
        _this2.isEnabled = !modelSelection.anchor.parent.is('element', 'codeBlock');
      });

      this._enableTransformationWatchers();
    }
    /**
     * Create new TextWatcher listening to the editor for typing and selection events.
     *
     * @private
     */

  }, {
    key: "_enableTransformationWatchers",
    value: function _enableTransformationWatchers() {
      var editor = this.editor;
      var model = editor.model;
      var input = editor.plugins.get('Input');
      var normalizedTransformations = normalizeTransformations(editor.config.get('typing.transformations'));

      var testCallback = function testCallback(text) {
        var _iterator = _createForOfIteratorHelper(normalizedTransformations),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var normalizedTransformation = _step.value;
            var from = normalizedTransformation.from;
            var match = from.test(text);

            if (match) {
              return {
                normalizedTransformation: normalizedTransformation
              };
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      var watcherCallback = function watcherCallback(evt, data) {
        if (!input.isInput(data.batch)) {
          return;
        }

        var _data$normalizedTrans = data.normalizedTransformation,
            from = _data$normalizedTrans.from,
            to = _data$normalizedTrans.to;
        var matches = from.exec(data.text);
        var replaces = to(matches.slice(1));
        var matchedRange = data.range;
        var changeIndex = matches.index;
        model.enqueueChange(function (writer) {
          for (var i = 1; i < matches.length; i++) {
            var match = matches[i];
            var replaceWith = replaces[i - 1];

            if (replaceWith == null) {
              changeIndex += match.length;
              continue;
            }

            var replacePosition = matchedRange.start.getShiftedBy(changeIndex);
            var replaceRange = model.createRange(replacePosition, replacePosition.getShiftedBy(match.length));
            var attributes = getTextAttributesAfterPosition(replacePosition);
            model.insertContent(writer.createText(replaceWith, attributes), replaceRange);
            changeIndex += replaceWith.length;
          }
        });
      };

      var watcher = new TextWatcher(editor.model, testCallback);
      watcher.on('matched:data', watcherCallback);
      watcher.bind('isEnabled').to(this);
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TextTransformation';
    }
  }]);

  return TextTransformation;
}(Plugin); // Normalizes the configuration `from` parameter value.
// The normalized value for the `from` parameter is a RegExp instance. If the passed `from` is already a RegExp instance,
// it is returned unchanged.
//
// @param {String|RegExp} from
// @returns {RegExp}


export { TextTransformation as default };

function normalizeFrom(from) {
  if (typeof from == 'string') {
    return new RegExp("(".concat(escapeRegExp(from), ")$"));
  } // `from` is already a regular expression.


  return from;
} // Normalizes the configuration `to` parameter value.
// The normalized value for the `to` parameter is a function that takes an array and returns an array. See more in the
// configuration description. If the passed `to` is already a function, it is returned unchanged.
//
// @param {String|Array.<null|String>|Function} to
// @returns {Function}


function normalizeTo(to) {
  if (typeof to == 'string') {
    return function () {
      return [to];
    };
  } else if (to instanceof Array) {
    return function () {
      return to;
    };
  } // `to` is already a function.


  return to;
} // For given `position` returns attributes for the text that is after that position.
// The text can be in the same text node as the position (`foo[]bar`) or in the next text node (`foo[]<$text bold="true">bar</$text>`).
//
// @param {module:engine/model/position~Position} position
// @returns {Iterable.<*>}


function getTextAttributesAfterPosition(position) {
  var textNode = position.textNode ? position.textNode : position.nodeAfter;
  return textNode.getAttributes();
} // Returns a RegExp pattern string that detects a sentence inside a quote.
//
// @param {String} quoteCharacter The character to create a pattern for.
// @returns {String}


function buildQuotesRegExp(quoteCharacter) {
  return new RegExp("(^|\\s)(".concat(quoteCharacter, ")([^").concat(quoteCharacter, "]*)(").concat(quoteCharacter, ")$"));
} // Reads text transformation config and returns normalized array of transformations objects.
//
// @param {module:typing/texttransformation~TextTransformationDescription} config
// @returns {Array.<{from:String,to:Function}>}


function normalizeTransformations(config) {
  var extra = config.extra || [];
  var remove = config.remove || [];

  var isNotRemoved = function isNotRemoved(transformation) {
    return !remove.includes(transformation);
  };

  var configured = config.include.concat(extra).filter(isNotRemoved);
  return expandGroupsAndRemoveDuplicates(configured).filter(isNotRemoved) // Filter out 'remove' transformations as they might be set in group
  .map(function (transformation) {
    return TRANSFORMATIONS[transformation] || transformation;
  }).map(function (transformation) {
    return {
      from: normalizeFrom(transformation.from),
      to: normalizeTo(transformation.to)
    };
  });
} // Reads definitions and expands named groups if needed to transformation names.
// This method also removes duplicated named transformations if any.
//
// @param {Array.<String|Object>} definitions
// @returns {Array.<String|Object>}


function expandGroupsAndRemoveDuplicates(definitions) {
  // Set is using to make sure that transformation names are not duplicated.
  var definedTransformations = new Set();

  var _iterator2 = _createForOfIteratorHelper(definitions),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var transformationOrGroup = _step2.value;

      if (TRANSFORMATION_GROUPS[transformationOrGroup]) {
        var _iterator3 = _createForOfIteratorHelper(TRANSFORMATION_GROUPS[transformationOrGroup]),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var transformation = _step3.value;
            definedTransformations.add(transformation);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else {
        definedTransformations.add(transformationOrGroup);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return Array.from(definedTransformations);
}
/**
 * The text transformation definition object. It describes what should be replaced with what.
 *
 * The input value (`from`) can be passed either as a string or as a regular expression.
 *
 * * If a string is passed, it will be simply checked if the end of the input matches it.
 * * If a regular expression is passed, its entire length must be covered with capturing groups (e.g. `/(foo)(bar)$/`).
 * Also, since it is compared against the end of the input, it has to end with  `$` to be correctly matched.
 * See examples below.
 *
 * The output value (`to`) can be passed as a string, as an array or as a function.
 *
 * * If a string is passed, it will be used as a replacement value as-is. Note that a string output value can be used only if
 * the input value is a string, too.
 * * If an array is passed, it has to have the same number of elements as there are capturing groups in the input value regular expression.
 * Each capture group will be replaced with a corresponding string from the passed array. If a given capturing group should not be replaced,
 * use `null` instead of passing a string.
 * * If a function is used, it should return an array as described above. The function is passed one parameter &mdash; an array with matches
 * by the regular expression. See the examples below.
 *
 * A simple string-to-string replacement:
 *
 *		{ from: '(c)', to: '©' }
 *
 * Change quote styles using a regular expression. Note how all the parts are in separate capturing groups and the space at the beginning
 * and the text inside quotes are not replaced (`null` passed as the first and the third value in the `to` parameter):
 *
 *		{
 *			from: /(^|\s)(")([^"]*)(")$/,
 *			to: [ null, '“', null, '”' ]
 *		}
 *
 * Automatic uppercase after a dot using a callback:
 *
 *		{
 *			from: /(\. )([a-z])$/,
 *			to: matches => [ null, matches[ 1 ].toUpperCase() ]
 *		}
 *
 * @typedef {Object} module:typing/texttransformation~TextTransformationDescription
 * @property {String|RegExp} from The string or regular expression to transform.
 * @property {String} to The text to transform compatible with `String.replace()`.
 */

/**
 * The configuration of the {@link module:typing/texttransformation~TextTransformation} feature.
 *
 * Read more in {@link module:typing/texttransformation~TextTransformationConfig}.
 *
 * @member {module:typing/texttransformation~TextTransformationConfig} module:typing/typing~TypingConfig#transformations
 */

/**
 * The configuration of the text transformation feature.
 *
 *		ClassicEditor
 *			.create( editorElement, {
 *				typing: {
 *					transformations: ... // Text transformation feature options.
 *				}
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * By default, the feature comes pre-configured
 * (via {@link module:typing/texttransformation~TextTransformationConfig#include `config.typing.transformations.include`}) with the
 * following groups of transformations:
 *
 * * Typography (group name: `typography`)
 *   - `ellipsis`: transforms `...` to `…`
 *   - `enDash`: transforms ` -- ` to ` – `
 *   - `emDash`: transforms ` --- ` to ` — `
 * * Quotations (group name: `quotes`)
 *   - `quotesPrimary`: transforms `"Foo bar"` to `“Foo bar”`
 *   - `quotesSecondary`: transforms `'Foo bar'` to `‘Foo bar’`
 * * Symbols (group name: `symbols`)
 *   - `trademark`: transforms `(tm)` to `™`
 *   - `registeredTrademark`: transforms `(r)` to `®`
 *   - `copyright`: transforms `(c)` to `©`
 * * Mathematical (group name: `mathematical`)
 *   - `oneHalf`: transforms `1/2` to: `½`
 *   - `oneThird`: transforms `1/3` to: `⅓`
 *   - `twoThirds`: transforms `2/3` to: `⅔`
 *   - `oneForth`: transforms `1/4` to: `¼`
 *   - `threeQuarters`: transforms `3/4` to: `¾`
 *   - `lessThanOrEqual`: transforms `<=` to: `≤`
 *   - `greaterThanOrEqual`: transforms `>=` to: `≥`
 *   - `notEqual`: transforms `!=` to: `≠`
 *   - `arrowLeft`: transforms `<-` to: `←`
 *   - `arrowRight`: transforms `->` to: `→`
 * * Misc:
 *   - `quotesPrimaryEnGb`: transforms `'Foo bar'` to `‘Foo bar’`
 *   - `quotesSecondaryEnGb`: transforms `"Foo bar"` to `“Foo bar”`
 *   - `quotesPrimaryPl`: transforms `"Foo bar"` to `„Foo bar”`
 *   - `quotesSecondaryPl`:  transforms `'Foo bar'` to `‚Foo bar’`
 *
 * In order to load additional transformations, use the
 * {@link module:typing/texttransformation~TextTransformationConfig#extra `transformations.extra` option}.
 *
 * In order to narrow down the list of transformations, use the
 * {@link module:typing/texttransformation~TextTransformationConfig#remove `transformations.remove` option}.
 *
 * In order to completely override the supported transformations, use the
 * {@link module:typing/texttransformation~TextTransformationConfig#include `transformations.include` option}.
 *
 * Examples:
 *
 *		const transformationsConfig = {
 *			include: [
 *				// Use only the 'quotes' and 'typography' groups.
 *				'quotes',
 *				'typography',
 *
 *				// Plus, some custom transformation.
 *				{ from: 'CKE', to: 'CKEditor' }
 *			]
 *		};
 *
 *		const transformationsConfig = {
 *			// Remove the 'ellipsis' transformation loaded by the 'typography' group.
 *			remove: [ 'ellipsis' ]
 *		}
 *
 * @interface TextTransformationConfig
 */

/* eslint-disable max-len */

/**
 * The standard list of text transformations supported by the editor. By default it comes pre-configured with a couple dozen of them
 * (see {@link module:typing/texttransformation~TextTransformationConfig} for the full list). You can override this list completely
 * by setting this option or use the other two options
 * ({@link module:typing/texttransformation~TextTransformationConfig#extra `transformations.extra`},
 * {@link module:typing/texttransformation~TextTransformationConfig#remove `transformations.remove`}) to fine-tune the default list.
 *
 * @member {Array.<module:typing/texttransformation~TextTransformationDescription>} module:typing/texttransformation~TextTransformationConfig#include
 */

/**
 * Additional text transformations that are added to the transformations defined in
 * {@link module:typing/texttransformation~TextTransformationConfig#include `transformations.include`}.
 *
 *		const transformationsConfig = {
 *			extra: [
 *				{ from: 'CKE', to: 'CKEditor' }
 *			]
 *		};
 *
 * @member {Array.<module:typing/texttransformation~TextTransformationDescription>} module:typing/texttransformation~TextTransformationConfig#extra
 */

/**
 * The text transformation names that are removed from transformations defined in
 * {@link module:typing/texttransformation~TextTransformationConfig#include `transformations.include`} or
 * {@link module:typing/texttransformation~TextTransformationConfig#extra `transformations.extra`}.
 *
 *		const transformationsConfig = {
 *			remove: [
 *				'ellipsis',    // Remove only 'ellipsis' from the 'typography' group.
 *				'mathematical' // Remove all transformations from the 'mathematical' group.
 *			]
 *		}
 *
 * @member {Array.<module:typing/texttransformation~TextTransformationDescription>} module:typing/texttransformation~TextTransformationConfig#remove
 */

/* eslint-enable max-len */